import * as React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { EmailSubjectLine } from "../molecules/EmailSubjectLine";
import { editor, moduleNameMap } from "../../config/config";
import { EmailLineContainer } from "../atoms/EmailLineContainer";
import { zohoApi } from "../../zohoApi";
import { staticToDynamicEmail } from "../../util/util";

export const EmailComponentPreview = ({
  module,
  relatedListModule,
  finalRecords,
  subject,
  emailContent,
  handlePreviewClose,
  orgId,
  apiKey,
  dataCenterUrl,
  fromEmail,
}) => {
  const [tempSub, setTempSub] = React.useState(subject);
  const [tempBody, setTempBody] = React.useState(emailContent);
  const [dataLoading, setDataLoading] = React.useState(false);
  let tempModule = !!relatedListModule ? relatedListModule : module;
  const contentWithSignatureRef = React.useRef();
  React.useEffect(() => {
    const getAndReplaceSignature = async () => {
      setDataLoading(true);
      const { data: signatureData } = await zohoApi.config.getConfigFromDB_2({
        moduleApiName: "userSignature",
        settingType: "",
        orgId,
        apiKey,
        dataCenterUrl,
      });

      const usersInDB = signatureData?.map((obj) => {
        const setting_schema = obj?.setting_schema;
        const parsedSettingSchema = JSON.parse(setting_schema);
        return parsedSettingSchema?.users;
      });

      let signature = usersInDB?.filter((obj) => {
        return obj?.email === fromEmail;
      })?.[0]?.signature;

      contentWithSignatureRef.current = emailContent.replace(
        "${!userSignature}",
        signature || ""
      );

      setTempBody(contentWithSignatureRef.current);
      setDataLoading(false);
    };
    if (orgId && apiKey && dataCenterUrl && fromEmail && emailContent) {
      getAndReplaceSignature();
    }
  }, [orgId, apiKey, dataCenterUrl, fromEmail, emailContent]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <EmailLineContainer>
        <Autocomplete
          size="small"
          onChange={async (e, value, reason) => {
            if (reason === "clear") {
              setTempSub(subject);
              if (contentWithSignatureRef.current) {
                setTempBody(contentWithSignatureRef.current);
                return;
              }
              setTempBody(emailContent);
              return;
            }
            const valueId = value?.id ? value?.id : value[`${tempModule}.id`];
            if (valueId) {
              setDataLoading(true);
              const data = await zohoApi.record.getFieldsAndData({
                entity: tempModule,
                entityId: valueId,
              });
              const tempSub = await staticToDynamicEmail(
                subject,
                data?.recordData
              );
              setTempSub(tempSub);
              const tempEmailBody = await staticToDynamicEmail(
                tempBody,
                data?.recordData
              );

              setTempBody(tempEmailBody);
              setDataLoading(false);
            }
          }}
          disablePortal
          disabled={!finalRecords}
          options={finalRecords}
          getOptionLabel={(obj) => {
            const optionLabel = obj?.id
              ? obj?.[moduleNameMap(tempModule)]
              : obj[`${tempModule}.${moduleNameMap(tempModule)}`];
            return optionLabel;
          }}
          renderInput={(params) => <TextField {...params} label="Record" />}
        />
      </EmailLineContainer>
      <EmailSubjectLine
        onChange={(e) => { }}
        value={tempSub}
        richTextEditor={false}
        onSelectRichTextEditor={() => { }}
      />

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          borderTop: "1px solid #d7e2ed",
          position: "relative",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: ".5em",
            overflowY: "auto",
          }}
        >
          {dataLoading ? (
            <Box
              sx={{ minHeight: "100%", display: "grid", placeItems: "center" }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{ minHeight: "100%" }}
              dangerouslySetInnerHTML={{ __html: tempBody }}
            />
          )}
        </Box>
      </Box>
      <EmailLineContainer sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          // disabled={ctaButtonInLoadingState}
          sx={{
            fontSize: "medium",
            fontWeight: "bold",
            textTransform: "capitalize",
            py: 0.15,
            px: "10px",
            mr: ".5em",
            height: "100%",
          }}
          variant="outlined"
          disableRipple
          onClick={() => {
            setTempSub(null);
            setTempBody(null);
            handlePreviewClose();
          }}
        >
          Close Preview
        </Button>
      </EmailLineContainer>
    </Box>
  );
};
